import theme from "@/constants/theme";

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'sticky',
    top: 0,
    paddingTop: 16,
    paddingBottom: 16,
    backgroundColor: theme.colors.background.primary,
    zIndex: 1,
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 50,
  },
  spinner: {
    width: 20,
    height: 20,
    borderColor: theme.colors.text.caption,
    borderBottomColor: theme.colors.background.secondary,
  },
  saved: {
    opacity: 0,
    color: theme.colors.success,
    display: 'flex',
    gap: 4,
    alignItems: 'center',
    marginRight: 8,
  },
};

export default styles;
